import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { http } from "@/lib/api";

const OrgCtx = createContext(null);
export const useOrg = () => useContext(OrgCtx);

export function OrgProvider({ children }) {
  const [orgs, setOrgs] = useState([]);
  const [orgId, setOrgId] = useState(localStorage.getItem("cl_org") || "");
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await http.get("/organisations");
      setOrgs(data);
      let current = localStorage.getItem("cl_org");
      if (!current || !data.find((o) => o.id === current)) {
        current = data[0]?.id || "";
      }
      setOrgId(current);
      if (current) localStorage.setItem("cl_org", current);
    } catch {
      setOrgs([]);
    } finally {
      setReady(true);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const selectOrg = useCallback((id) => { setOrgId(id); localStorage.setItem("cl_org", id); }, []);
  const org = useMemo(() => orgs.find((o) => o.id === orgId), [orgs, orgId]);

  const value = useMemo(
    () => ({ orgs, org, orgId, selectOrg, reloadOrgs: load, ready }),
    [orgs, org, orgId, selectOrg, load, ready]);

  return (
    <OrgCtx.Provider value={value}>
      {children}
    </OrgCtx.Provider>
  );
}
